<template>
    <div class="card card-basic card--blue card--activated h-auto">
        <div class="card__text">
            <ul class="related-news__wrapper list-unstyled">
                <li v-for="(newsitem, index) in news.items" :key="index">
                    <a :href="newsitem.url" :alt="newsitem.name">
                        <div class="update-item__divider">
                            <span class="small">
                                {{ newsitem.date }}
                            </span>
                        </div>
                        <span>{{ newsitem.name }}</span></a
                    >
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        news: {
            type: Object,
            default() {
                return {};
            }
        }
    }
};
</script>

<style lang="scss">
.related-news__wrapper li {
    background-color: $brand-white;
    padding: 10px 20px;
    margin: 0 -20px;

    &:nth-child(odd) {
        background-color: $brand-gray;
    }

    &:hover {
        /* background-color: $brand-blue;*/
        cursor: pointer;
        a {
            text-decoration: underline;
            color: $brand-green-dark-new;
        }
    }
}

.related-news__divider {
    border-bottom: dashed 1px $brand-black;
}
</style>
